import { render, staticRenderFns } from "./equipment-block.vue?vue&type=template&id=2a130ca8&"
import script from "./equipment-block.vue?vue&type=script&lang=js&"
export * from "./equipment-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports